var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    { attrs: { modalId: "downgrade-subscription-modal", size: "modal-lg" } },
    [
      _c(
        "ModalHeader",
        {
          attrs: {
            title: _vm.$t("xDowngradeYourPlan"),
            icon: "far fa-circle-dollar colorOrange mr-1"
          }
        },
        [
          _c("div", { staticClass: "cols-auto" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-icon-button btn-icon-button--gray",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.closeModal("downgrade-subscription-modal")
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ])
        ]
      ),
      _c("ModalBody", [
        _vm.currentSubscription && _vm.newSubscription
          ? _c(
              "div",
              {
                staticClass: "container",
                attrs: { "data-test-hook": "downgrade-plan-modal-body" }
              },
              [
                _c(
                  "b-row",
                  {
                    staticClass: "mb-3 text-center",
                    attrs: { "no-gutters": "" }
                  },
                  [
                    _c("p", { staticClass: "downgrade-desc" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("xDowngradingEffectDate", {
                              0: _vm
                                .$moment(
                                  _vm.currentSubscription
                                    .subscriptionRenewalDate
                                )
                                .format(_vm.$t("xShortDate"))
                            })
                          ) +
                          " "
                      )
                    ])
                  ]
                ),
                _c(
                  "b-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("DowngradeSubscriptionCard", {
                          attrs: {
                            "subscription-product": _vm.currentSubscription,
                            "apparatuses-to-downgrade": _vm.currentApparatuses,
                            "is-new-plan": false
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("DowngradeSubscriptionCard", {
                          attrs: {
                            "subscription-product": _vm.newSubscription,
                            "apparatuses-to-downgrade": _vm.currentApparatuses,
                            "is-new-plan": true
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-3" },
                  [
                    _c("b-col", { staticClass: "text-center" }, [
                      _c("p", { staticClass: "text-small legal-text" }, [
                        _vm._v(
                          "*" +
                            _vm._s(
                              _vm.$t(
                                "xPushNotificationsAreAvailableWithInstallation"
                              )
                            )
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _c(
                  "b-row",
                  {
                    staticClass: "mt-3 align-items-center",
                    attrs: { "no-gutters": "" }
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn mr-3 flex flex-grow-1",
                        staticStyle: { width: "48%" },
                        attrs: {
                          variant: "secondary",
                          "data-test-hook": "cancel-button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeModal(
                              "downgrade-subscription-modal"
                            )
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-primary flex flex-grow-1",
                        staticStyle: { width: "48%" },
                        attrs: {
                          variant: "warning",
                          "data-test-hook": "downgrade-modal-button-continue"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("openPayment")
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("xDowngradeNow")) + " ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }